import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { parseSideValues } from '@codex-brightworld/helpers';

const Space = styled.div.attrs(props => ({ 'data-qa': props.qa }))`
  ${(props) => {
    const {
      top, right, bottom, left
    } = parseSideValues(props.all);
    const topValue = parseInt(props.top, 10) || top;
    const rightValue = parseInt(props.right, 10) || right;
    const bottomValue = parseInt(props.bottom, 10) || bottom;
    const leftValue = parseInt(props.left, 10) || left;

    return css`
      ${props.property}: ${topValue}${props.unit} ${rightValue}${props.unit}
        ${bottomValue}${props.unit} ${leftValue}${props.unit};
    `;
  }}
`;

Space.propTypes = {
  /**
   * Supported format is the same as shorthand values for margin in CSS:
   * "10 20 30 40" means top, right, bottom, left;
   * "10 20 30"    means top, right and left, bottom;
   * "10 20"       means top and bottom, left and right;
   * "10"          means top and right and bottom and left
   */
  all: PropTypes.string,

  /**
   * Expects value without unit
   */
  top: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),

  /**
   * Expects value without unit
   */
  bottom: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),

  /**
   * Expects value without unit
   */
  left: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),

  /**
   * Expects value without unit
   */
  right: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),

  property: PropTypes.oneOf(['padding', 'margin']),
  unit: PropTypes.string,
  qa: PropTypes.string
};

Space.defaultProps = {
  all: undefined,
  top: undefined,
  bottom: undefined,
  left: undefined,
  right: undefined,
  property: 'padding',
  unit: 'px',
  qa: undefined
};

/** @component */
export default Space;
